/**
 * @generated SignedSource<<39aac53bea4b27a1aff5aa2a9532084b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateProjectPortalConfigInput = {
  psaProjectId: string;
  legacyPsaProjectId?: string | null;
  showInClientPortal?: boolean | null;
  portalPhaseStatusVisible?: boolean | null;
  psaClientExternalId?: string | null;
  clientName?: string | null;
  projectName?: string | null;
  projectStatus?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateProjectPortalConfigMutation$variables = {
  input: UpdateProjectPortalConfigInput;
};
export type updateProjectPortalConfigMutation$data = {
  readonly updateProjectPortalConfig: {
    readonly projectPortalConfig: {
      readonly showInClientPortal: boolean | null;
      readonly portalPhaseStatusVisible: boolean | null;
    } | null;
  } | null;
};
export type updateProjectPortalConfigMutation = {
  variables: updateProjectPortalConfigMutation$variables;
  response: updateProjectPortalConfigMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateProjectPortalConfigPayload",
    "kind": "LinkedField",
    "name": "updateProjectPortalConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectPortalConfig",
        "kind": "LinkedField",
        "name": "projectPortalConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showInClientPortal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "portalPhaseStatusVisible",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateProjectPortalConfigMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateProjectPortalConfigMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f354f9610f5f51b41c79e4ef2ecd73f3",
    "id": null,
    "metadata": {},
    "name": "updateProjectPortalConfigMutation",
    "operationKind": "mutation",
    "text": "mutation updateProjectPortalConfigMutation(\n  $input: UpdateProjectPortalConfigInput!\n) {\n  updateProjectPortalConfig(input: $input) {\n    projectPortalConfig {\n      showInClientPortal\n      portalPhaseStatusVisible\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bcd58203c6317c43d2cd6e71c692537d";

export default node;
